import React, { useContext } from "react";
import { DataContext } from '../../data/DataContext';
import { DropDown, Input } from "../controls";
import { tipoDocumentos, parentescos } from "../../data/MochaData";


const Step4 = () => {

    const { VivirSeguro, setVivirSeguro, changeHandler } = useContext(DataContext);
    const EdadPattern = "^[1-9]$|^[1-9][0-9]$|^(100)$";
    const PorcentajePattern = "^[1-9]$|^[1-9][0-9]$|^(100)$";

    const onClickNuevoBeneficiario = () => {
        setVivirSeguro({ ...VivirSeguro, esBeneficiario2: true });
    }

    const onClickEliminarBeneficiario = () => {
        setVivirSeguro({
            ...VivirSeguro, esBeneficiario2: false, nombresApellidos2: '', parentesco2: '', edad2: 0, porcentajeBeneficio2: 0,
            tipoIdentificacionRepresentante2: '', nombreRepresentante2: '', apellidoRepresentante2: ''
        });
    }

    return (
        <div className="step">
            <div className="step-container-vivirseguro">
                <div>
                    <span className="title2">Declaraci&oacute;n de Beneficiarios</span>
                </div>
                <div>
                    <span className="title3">Podes declarar hasta 2 beneficiarios. Puede ser tu pareja, tus hijos, tus pap&aacute;s, ¡vos decidis!</span>
                </div>
                <Input label="Nombres y Apellidos" value={VivirSeguro.nombresApellidos1} field="nombresApellidos1" onChange={changeHandler} />
                <DropDown containBlank={true} isRequired={true} label="Parentesco" dataProvider={parentescos} valueSelect={VivirSeguro.parentesco1} fieldSelect="parentesco1" field="parentesco1" isrequired={true} onChangeSelect={changeHandler} />
                <div className="col-vivirseguro">
                    <Input type="mask" pattern={EdadPattern} label="Edad" value={VivirSeguro.edad1} field="edad1" onChange={changeHandler} title="Edad inválido" />
                    <Input type="mask" pattern={PorcentajePattern} label="% de Beneficio" value={VivirSeguro.porcentajeBeneficio1} field="porcentajeBeneficio1" onChange={changeHandler} title="Porcentaje inválido" />
                </div>
                {VivirSeguro.edad1 < 18 && VivirSeguro.edad1 > 0 &&
                    <>
                        <div className="title6-vs-bene mt-15 mb-25">
                            Al ser un menor de edad, porfavor ingresa los datos del albacea o representante del beneficiario
                        </div>
                        <DropDown isRequired={true} label="Tipo de identificación"
                            dataProvider={tipoDocumentos} onChange={changeHandler}
                            valueSelect={VivirSeguro.tipoIdentificacionRepresentante1}
                            fieldSelect="tipoIdentificacionRepresentante1"
                            field="tipoIdentificacionRepresentante1" onChangeSelect={changeHandler} />
                        {VivirSeguro.tipoIdentificacionRepresentante1 === "1" &&
                            <Input type="mask" label="Número de identificación" value={VivirSeguro.numeroIdentificacionRepresentante1} field="numeroIdentificacionRepresentante1" onChange={changeHandler} mask="999-999999-9999a" pattern="\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w" title="Documento invalido" />
                        }
                        {VivirSeguro.tipoIdentificacionRepresentante1 !== "1" &&
                            <Input label="Número de identificación" value={VivirSeguro.numeroIdentificacionRepresentante1} field="numeroIdentificacionRepresentante1" onChange={changeHandler} />
                        }
                        <Input label="Nombres" value={VivirSeguro.nombreRepresentante1} field="nombreRepresentante1" onChange={changeHandler} />
                        <Input label="Apellidos" value={VivirSeguro.apellidoRepresentante1} field="apellidoRepresentante1" onChange={changeHandler} />
                    </>
                }
                {VivirSeguro.esBeneficiario2 === false &&
                    <div className="control-button-beneficiario mt-20">
                        <button className="control-button-btn-beneficiario" onClick={e => (e.preventDefault(), onClickNuevoBeneficiario())}><span>+</span></button>
                        <div className="title6-vs-bene">Pulsá aquí para agregar más beneficiarios</div>
                    </div>
                }
                {VivirSeguro.esBeneficiario2 === true &&
                    <>
                        <div className="control-button-beneficiario2 mb-20 mt-30">
                            <div className="title7-vs-bene">Datos del segundo beneficiario</div>
                            <button className="control-button-btn-beneficiario2 ml-20" onClick={e => (e.preventDefault(), onClickEliminarBeneficiario())}><span>-</span></button>
                        </div>
                        <Input label="Nombres y Apellidos" value={VivirSeguro.nombresApellidos2} field="nombresApellidos2" onChange={changeHandler} />
                        <DropDown containBlank={true} isRequired={true} label="Parentesco" dataProvider={parentescos} valueSelect={VivirSeguro.parentesco2} fieldSelect="parentesco2" field="parentesco2" isrequired={true} onChangeSelect={changeHandler} />
                        <div className="col-vivirseguro">
                            <Input type="mask" pattern={EdadPattern} label="Edad" value={VivirSeguro.edad2} field="edad2" onChange={changeHandler} title="Edad inválido" />
                            <Input type="mask" pattern={PorcentajePattern} label="% de Beneficio" value={VivirSeguro.porcentajeBeneficio2} field="porcentajeBeneficio2" onChange={changeHandler} title="Porcentaje inválido" />
                        </div>
                        {VivirSeguro.edad2 < 18 && VivirSeguro.edad2 > 0 &&
                            <>
                                <div className="title6-vs-bene mt-15 mb-25">
                                    Al ser un menor de edad, porfavor ingresa los datos del albacea o representante del beneficiario </div>
                                <DropDown isRequired={true} label="Tipo de identificación"
                                    dataProvider={tipoDocumentos} onChange={changeHandler}
                                    valueSelect={VivirSeguro.tipoIdentificacionRepresentante2}
                                    fieldSelect="tipoIdentificacionRepresentante2"
                                    field="tipoIdentificacionRepresentante2" onChangeSelect={changeHandler} />
                                {VivirSeguro.tipoIdentificacionRepresentante2 === "1" &&
                                    <Input type="mask" label="Número de identificación" value={VivirSeguro.numeroIdentificacionRepresentante2} field="numeroIdentificacionRepresentante2" onChange={changeHandler} mask="999-999999-9999a" pattern="\d\d\d-\d\d\d\d\d\d-\d\d\d\d\w" title="Documento invalido" />
                                }
                                {VivirSeguro.tipoIdentificacionRepresentante2 !== "1" &&
                                    <Input label="Número de identificación" value={VivirSeguro.numeroIdentificacionRepresentante2} field="numeroIdentificacionRepresentante2" onChange={changeHandler} />
                                }
                                <Input label="Nombres" value={VivirSeguro.nombreRepresentante2} field="nombreRepresentante2" onChange={changeHandler} />
                                <Input label="Apellidos" value={VivirSeguro.apellidoRepresentante2} field="apellidoRepresentante2" onChange={changeHandler} />
                            </>
                        }
                    </>
                }
            </div>
        </div>
    );

}
export default Step4;